import {
    SHORT_EXCESS_REGISTER_REPORT_REQUEST,
    SHORT_EXCESS_REGISTER_REPORT_SUCCESS,
    SHORT_EXCESS_REGISTER_REPORT_FAILURE,
    SHORT_EXCESS_REGISTER_FILTER_REPORT_REQUEST,
    SHORT_EXCESS_REGISTER_FILTER_REPORT_SUCCESS,
    SHORT_EXCESS_REGISTER_FILTER_REPORT_FAILURE,
  } from "../types/short-excess-register-types";
  
  const initialState = {
    shortExcessRegisterReport: {},
    shortExcessRegisterFilterReport: {},
    loading: false,
    error: null,
  };
  
  const shortExcessRegisterReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case SHORT_EXCESS_REGISTER_REPORT_REQUEST, SHORT_EXCESS_REGISTER_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case SHORT_EXCESS_REGISTER_REPORT_SUCCESS: {
        return {
          ...state,
          shortExcessRegisterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case SHORT_EXCESS_REGISTER_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          shortExcessRegisterFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case SHORT_EXCESS_REGISTER_REPORT_FAILURE, SHORT_EXCESS_REGISTER_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default shortExcessRegisterReportReducer;
  